import { useSelector } from "react-redux";
import BasicCardDocumentos from "./BasicCardDocumentos";
import InputForm from "./InputFormV2";
import { State } from "../../../reducers";
import useFormaPago from "../../../actions/forma-pago.actions";

import DolarIcon from '../../../media/felsv/DollarSecondary.svg'
import { Pagination } from "../../../components/Pagination";
import { useEffect, useState } from "react";
import ModalConfirm from "../../../components/Modals/Generales/ModalConfirm";

export default function FormaPago ({totalAPagar} : {totalAPagar?: string}){
    const {formFormaPago, errorsFormaPago, pagos, tablePagos} = useSelector((state: State) => state.formaPago)
    const {condicionesPago, formasPago, plazosPago} = useSelector((state: State) => state.catalogos)
    const {onChangeForm, button_agregarPago, setTablePagos, actionButton_quitarpago, vaciarPagos, calculosPagos} = useFormaPago(totalAPagar)
    const [modalAdvertencia, setModalAdvertencia] = useState(false)
    const [condicion, setCondicion] = useState('')

    useEffect(() => {
        setTablePagos(pagos)
    }, [pagos.length])

    const onChangeCondicion = (e: any) => {
        if(pagos.length > 0){
            setCondicion(e.value)
            setModalAdvertencia(true)
        } else {
            onChangeForm('condicion', e.value)
        }
    }

    const confirmChangeCondicion = () => {
        onChangeForm('condicion', condicion)
        vaciarPagos()
        setModalAdvertencia(false)
    }

    let condicionContadoCode = condicionesPago.find((condicion) => condicion.valor === 'Contado')?.codigo

    return (
        <>
        {modalAdvertencia && <ModalConfirm actionConfirm = {confirmChangeCondicion} closeModalConfirm = {() => setModalAdvertencia(false)} title = 'Cambio de condición' detail = 'Al realizar esta acción se eliminarán los pagos agregados previamente, ¿Deseas continuar?'/>}
        <div className="w-layout-layout bill-section wf-layout-layout">
        <BasicCardDocumentos style={{boxShadow: 'none', padding: '0'}} title="Forma de pago" size="l">
                <InputForm required error = {errorsFormaPago.condicion} disabled = {parseFloat(totalAPagar || '0') === 0} onChange = {onChangeCondicion} label = 'Condición' options = {condicionesPago} keyNameText = 'valor' keyNameValue = 'codigo' value = {formFormaPago.condicion} type = 'select'/>
            <hr className="separador"/>
            <div className='w-layout-hflex h-inputs'>
                <InputForm required error = {errorsFormaPago.formaPago} disabled = {parseFloat(totalAPagar || '0') === 0} onChange = {(e: any) => onChangeForm('formaPago', e.value)} label = 'Forma de pago' options = {formasPago} keyNameText = 'valor' keyNameValue = 'codigo' value = {formFormaPago.formaPago} type = 'select'/>
                <InputForm required error = {errorsFormaPago.monto} disabled = {parseFloat(totalAPagar || '0') === 0} leftIcon = {DolarIcon} onChange = {(e: any) => onChangeForm(e.target.name, e.target.value)} name = 'monto' label = 'Monto' value = {formFormaPago.monto}/>
                <InputForm maxLenght = {35} error = {errorsFormaPago.numeroDocumento} disabled = {parseFloat(totalAPagar || '0') === 0} onChange = {(e: any) => onChangeForm(e.target.name, e.target.value)} name = 'numeroDocumento' label = 'Número de documento' value = {formFormaPago.numeroDocumento}/>
            </div>
            {formFormaPago.condicion !== condicionContadoCode &&
            <div className='w-layout-hflex h-inputs'>
                <InputForm error = {errorsFormaPago.plazo} disabled = {parseFloat(totalAPagar || '0') === 0} onChange = {(e: any) => onChangeForm('plazo', e.value)} label = 'Plazo' options = {plazosPago} keyNameText = 'valor' keyNameValue = 'codigo' value = {formFormaPago.plazo} type = 'select'/>
                <InputForm maxLenght = {3} error = {errorsFormaPago.periodo} disabled = {parseFloat(totalAPagar || '0') === 0} onChange = {(e: any) => onChangeForm(e.target.name, e.target.value)} name = 'periodo' label = 'Período' value = {formFormaPago.periodo} />
            </div>
            }
            <div style={{display: 'flex', justifyContent: 'end'}}>
                <button className="button w-auto" onClick={button_agregarPago}>Agregar pago</button>
            </div>
            {pagos.length > 0 ?
            <>
            <hr className="separador"/>
            <div style={{overflowX: 'auto'}} className="tab-plane">
                <table className="table-main-responsive responsive-table-main td-left table-pointer">
                    <thead>
                        <tr>
                            <td>Forma de pago</td>
                            <td>Monto</td>
                            <td>Número de documento</td>
                            <td>Plazo</td>
                            <td>Período</td>
                            <td>Acciones</td>
                        </tr>
                    </thead>
                    <tbody>
                        {tablePagos.map((pago, i) => (
                            <tr key={i}>
                                <td data-label="Forma de pago">{formasPago.find((forma) => forma.codigo === pago.formaPago)?.valor}</td>
                                <td data-label="Monto">{parseFloat(pago.monto).toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 3, style: 'currency', currency: 'USD'})}</td>
                                <td data-label="Número de documento" dangerouslySetInnerHTML={{ __html: pago.numeroDocumento || "&nbsp;"}}></td>
                                <td data-label="Plazo" dangerouslySetInnerHTML={{ __html: plazosPago.find((plazo) => plazo.codigo === pago.plazo)?.valor || "&nbsp;"}}></td>
                                <td data-label="Período" dangerouslySetInnerHTML={{ __html: pago.periodo || "&nbsp;"}}></td>
                                <td data-label="Acciones"><button style={{borderRadius: '4px', color: '#fff', background: 'red'}} onClick={() => actionButton_quitarpago(pago.id)}>Quitar</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Pagination data = {pagos} items = {5} state = {(items: Array<any>) => setTablePagos(items)}/>
            </>
            :

            <div style={{display: 'flex', width: '100%', justifyContent: 'center'}}>
                <h3 className="card-title l">Sin pagos agregados</h3>
            </div>
            }
            <div className="cf-calculos-producto">
                        <table>
                            <tbody>
                                <tr className="cf-total">
                                    <td>Total</td>
                                    <td>{calculosPagos().montoTotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                            </tbody>
                        </table>
            </div>
        </BasicCardDocumentos>
        </div>
        </>
    )
}